/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const tutorialMessages = defineMessages({
    machineLearnedEntityLabel: {
        id: 'entities.createEntityModal.machineLearnedEntityLabel',
        defaultMessage: 'Machine learned entities'
    },
    machineLearnedEntityDescription: {
        id: 'entities.createEntityModal.machineLearnedEntityDescription',
        defaultMessage: `are learned from context. Use an ML entity to identify data that are not always
            well-formatted but have the same meaning. An ML entity can be composed of smaller subentities, each of which can have its own properties.`
    },
    machineLearnedEntityImageDescriptionSimple: {
        id: 'entities.createEntityModal.machineLearnedEntityImageDescriptionSimple',
        defaultMessage: `Example diagram of an entity. In the phrase: "Book 2 adult business tickets to Arrabury Airport",
        "2 adult business" would be labeled as the TicketOrder entity.`
    },
    machineLearnedEntityImageDescriptionNodes: {
        id: 'entities.createEntityModal.machineLearnedEntityImageDescriptionNodes',
        defaultMessage: `Example diagram of an entity with subentities.
        In the phrase: "Book 2 adult business tickets to Arrabury Airport", "2 adult business" would be labeled as the TicketOrder entity.
        "2" would be labeled as the subentity "Number", "adult" would be labeled as the subentity "PassengerClass",
        and "business" would be labeled as the subentity "TravelClass".`
    },
    listEntityLabel: {
        id: 'entities.createEntityModal.listEntityLabel',
        defaultMessage: 'List entities'
    },
    listEntityDescription: {
        id: 'entities.createEntityModal.listEntityDescription',
        defaultMessage: `represent a fixed, closed set of related words along with their synonyms. A list entity is not machine-learned.
        It is an exact text match. LUIS marks any match to an item in any list as an entity in the response.`
    },
    listEntityImageDescription: {
        id: 'entities.createEntityModal.listEntityImageDescription',
        defaultMessage: `Example diagram of a list entity. In the phrase: "Book 2 adult business tickets to Arrabury Airport",
        "Arrabury Airport" is an example of a list entity named "airport". "Arrabury Airport" is a synonym for the list item "AAB".`
    },
    regexEntityLabel: {
        id: 'entities.createEntityModal.regexEntityLabel',
        defaultMessage: 'Regex entities'
    },
    regexEntityDescription: {
        id: 'entities.createEntityModal.regexEntityDescription',
        defaultMessage: `extract an entity based on a regular expression pattern you provide.
            Regex entities are a good fit for the data that are consistently formatted with any variation that is also consistent.`
    },
    regexEntityImageDescription: {
        id: 'entities.createEntityModal.regexEntityImageDescription',
        defaultMessage: `Example diagram of a regex entity. In the phrase: "Book 2 adult business tickets on flight SU 2996",
        "flight SU 2996" is an example of with a regex entity named "flightNumber". "flightNumber" is defined by a regular expression.`
    },
    patternAnyEntityLabel: {
        id: 'entities.createEntityModal.patternAnyEntityLabel',
        defaultMessage: 'Pattern.any entities'
    },
    patternAnyEntityDescription: {
        id: 'entities.createEntityModal.patternAnyEntityDescription',
        defaultMessage: 'are variable-length placeholders used only in a pattern’s template utterance to mark where entities begin and end.'
    }
});
